import { LoadingContext } from 'context/Loading';
import React, {
  useCallback, useContext, useEffect, useState,
} from 'react';
import CalendarView from 'screens/User/Calendar/components/View';
import handlePromise from 'utils/Promise';
import EventService from 'services/api/Event';
import { useSelector } from 'react-redux';
import { selectUserAccount } from 'store/User';

function Calendar() {
  const { toggleLoading } = useContext( LoadingContext );
  const [events, setEvents] = useState<[]>();
  const userAccountId = useSelector( selectUserAccount );

  const getData = useCallback( async ( month: number, year: number ) => {
    toggleLoading( true );
    const [, response, data] = await handlePromise(
      EventService.getEventByAccount( userAccountId as string, {
        month,
        year,
      } ),
    );

    if ( response?.ok ) {
      setEvents( data.map( ( item: any ) => ( {
        id: item.eventoId,
        title: item.titulo,
        start: new Date( item.fechaInicio ).toISOString().split( 'T' )[0],
        // allDay: item.allDate,
        backgroundColor: '#BFCAEE',
        borderColor: '#263B78',
        ...item,
      } ) ) );
    }
    toggleLoading( false );
  }, [] );

  useEffect( () => {
    const date = new Date();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    getData( month, year );
  }, [] );

  return (
    <CalendarView
      events={events}
      getData={getData}
    />
  );
}

export default Calendar;
